export type TimeSeriesYAxisMode = "auto" | "single" | "dual" | "normalized";

export type ResolvedTimeSeriesYAxisMode = Exclude<TimeSeriesYAxisMode, "auto">;

/**
 * 可視メトリクス数に応じて time-series の Y 軸モードを決定する。
 *
 * - auto: 1指標=single, 2指標=dual, 3指標以上=normalized
 * - 明示指定: 指定モードをそのまま優先
 */
export function resolveTimeSeriesYAxisMode(args: {
  mode?: TimeSeriesYAxisMode | null;
  metricGroupCount: number;
}): ResolvedTimeSeriesYAxisMode {
  const { mode, metricGroupCount } = args;
  if (mode === "single" || mode === "dual" || mode === "normalized") {
    return mode;
  }

  if (metricGroupCount >= 3) return "normalized";
  if (metricGroupCount === 2) return "dual";
  return "single";
}
